
import { PermissionWrapperProps } from '@/core/interfaces/usestate-interfaces';
import * as authHelper from '@modules/auth/core/AuthHelpers'


const PermissionWrapper: React.FC<PermissionWrapperProps> = ({ permission, action, children }) => {

    return authHelper.checkPermission(permission, action) ? <>{children}</> : null;
};

export default PermissionWrapper;